import React from "react";
import Header from "../components/header";

const Layout = ({ children }) => {
  return <Header>{children}</Header>;
};

export default Layout;
